import {
  IUserAccountStatus,
  IUserRawAccountStatus,
} from '~/shared/types/userTypes'

export const getUserAccountStatusFromRawStatus = (
  rawAccountStatus: IUserRawAccountStatus,
): IUserAccountStatus => ({
  existingUuid: rawAccountStatus.uuid,
  hasAccount: rawAccountStatus.has_account,
  hasAccessToApp: rawAccountStatus.access_to_app,
})
